import { createApiCall2, MethodType, URI } from "../Api";
import { DepartmentListData } from "models/departmentList";

export const fetchDepartmentList = (payload: DepartmentListData) => {
  return createApiCall2(MethodType.GET, URI.USERS.GETDEPARTMENTLIST, payload);
};
